import React from 'react';
import { Box, Stepper, Step, StepLabel } from '@mui/material';

const BrokerStepIndicator = ({ activeStep, stepLabels }) => {
  return (
    <Box sx={{ mb: 2.5 }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {stepLabels.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default BrokerStepIndicator;
